/*
 * Copyright (c) 2022 Robert J Whelton. All rights reserved.
 */

import * as React from "react"
import {useTheme} from "@mui/material/styles"
import useMediaQuery from "@mui/material/useMediaQuery"
import AppBar from "@mui/material/AppBar"
import Box from "@mui/material/Box"
import IconButton from "@mui/material/IconButton"
import Toolbar from "@mui/material/Toolbar"
import Typography from "@mui/material/Typography"
import SettingsIcon from "@mui/icons-material/Settings"
import LoginIcon from '@mui/icons-material/Login'
import {navigate} from "gatsby"
import {Fade as Hamburger} from "hamburger-react"

import {ToggleFunctionType} from "./Layout"
import LogoIcon from "../components/LogoIcon"
import {getUser, isLoggedIn} from "../services/auth"
import {useEffect, useState} from "react"

interface HeaderProps {
  navigatorOpen: boolean
  toggleNavigator: ToggleFunctionType
  settingsMenuOpen: boolean
  toggleSettingsMenu: ToggleFunctionType
  title: string
}

const Header: React.FC<HeaderProps> = ({
                                         navigatorOpen, toggleNavigator,
                                         settingsMenuOpen, toggleSettingsMenu,
                                         title
                                       }) => {
  const [user, setUser] = useState({username: undefined})
  const theme = useTheme()
  const notExtraSmall = useMediaQuery(theme.breakpoints.up("sm"))

  useEffect(() => {
    if (!user.username && isLoggedIn()) setUser(getUser())
    else if (!!user.username && !isLoggedIn()) setUser({username: undefined})
  })

  return (
    <Box sx={{flexGrow: 1}}>
      <AppBar position="fixed" sx={{zIndex: (theme) => theme.zIndex.drawer + 4}}>
        <Toolbar variant="dense">
          <IconButton
            size="medium"
            edge="start"
            color="inherit"
            aria-label="menu"
            sx={{mr: 1.5, padding: 0}}
            onClick={e => {
              e.preventDefault()
              toggleNavigator(navigatorOpen)(e)
              toggleSettingsMenu(true)(e)
            }}
          >
            <Hamburger size={30} toggled={navigatorOpen}/>
          </IconButton>
          <IconButton
            size="medium"
            edge="start"
            color="default"
            aria-label="home"
            onClick={(e) => {
              e.preventDefault()
              if (!notExtraSmall) toggleNavigator(true)()
              navigate("/")
            }}
          >
            <LogoIcon/>
          </IconButton>
          <Typography variant={"h5"} sx={{flexGrow: 1}}>
            {title}
          </Typography>
          {
            <IconButton
              size="large"
              edge="end"
              color="inherit"
              aria-label="menu"
              onClick={(e) => {
                e.preventDefault()
                if (!user.username) {
                  navigate("/login")
                } else {
                  toggleSettingsMenu(settingsMenuOpen)(e)
                  toggleNavigator(true)(e)
                }
              }}
            >
              <LoginIcon sx={{width: !user.username ? "auto" : 0}}/>
              <SettingsIcon sx={{width: !!user.username ? "auto" : 0}}/>
            </IconButton>
          }
        </Toolbar>
      </AppBar>
    </Box>
  )
}

export default Header
